import styled from 'styled-components'

export const CARD_MAX_WIDTH = '830px'

export const StyledContainer = styled.div`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding: 42px 0 151.95px;
  background: linear-gradient(174.82deg, #f65e0e 15.55%, #ffffff 97.33%);

  .bg-item {
    position: absolute;
  }

  .bg-item-top-left {
    width: 86px;
    height: 108px;
    top: 332.68px;
    left: 0;
  }

  .bg-item-bottom-left {
    width: 91px;
    height: 134px;
    top: 1588.45px;
    left: 0;
  }

  .bg-item-top-right {
    width: 100px;
    height: 133px;
    top: 598.53px;
    right: 0;
  }

  .bg-item-bottom-right {
    width: 55px;
    height: 108px;
    top: 2454.69px;
    right: 0;
  }

  ${({ theme }) => theme.media.sm`
    padding: 0;

    .bg-item {
      display: none;
    }
  `}
`

export const StyledContent = styled.div`
  width: 100%;
  max-width: ${CARD_MAX_WIDTH};
  background: #f65e0e;
  border-radius: 24.59px;
  overflow: hidden;
  padding-bottom: 184.18px;

  ${({ theme }) => theme.media.sm`
    max-width: 100%;
    border-radius: 0;
    padding-bottom: 61.6px;
  `}
`

export const StyledBanner = styled.div`
  position: relative;
  width: 100%;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 396.33px;
    background: linear-gradient(
      180deg,
      #ff7513 14.96%,
      rgba(253, 188, 84, 0) 100%
    );
    pointer-events: none;
    z-index: 1;
  }

  ${({ theme }) => theme.media.sm`
    &::before {
      display: none;
    }
  `}
`

export const StyledTitleWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  gap: 22px;
  top: 105.42px;
  left: 0;
  right: 0;
  z-index: 2;

  ${({ theme }) => theme.media.sm`
    gap: 9.72px;
    top: 45.2px;
  `}
`

export const StyledTitle = styled.h1`
  font-size: 53.43px;
  font-weight: 700;
  color: #533000;
  margin-bottom: 0;

  ${({ theme }) => theme.media.sm`
    font-size: 26px;
  `}
`

export const StyledSubtitle = styled.h2`
  font-size: 34.84px;
  font-weight: 900;
  color: #533000;
  margin-bottom: 0;

  ${({ theme }) => theme.media.sm`
    font-size: 16px;
  `}
`

export const StyledBannerImage = styled.img`
  width: 100%;
`

export const StyledSection = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  gap: 16px;
  margin-bottom: 76.85px;

  ${({ theme }) => theme.media.sm`
    gap: 10px;
    margin-bottom: 35px;
  `}
`

export const StyledSectionTitle = styled.h3`
  font-size: 27.67px;
  font-weight: 700;
  text-align: center;
  color: #fef38b;
  margin-bottom: 0;

  ${({ theme }) => theme.media.sm`
    font-size: 18px;
  `}
`

export const StyledSectionSubTitle = styled.p`
  font-size: 22.29px;
  font-weight: 400;
  text-align: center;
  color: #fef38b;
  margin-bottom: 0;

  ${({ theme }) => theme.media.sm`
    font-size: 13px;
  `}
`

export const StyledSectionLinkWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
`

export const StyledSectionLink = styled.a`
  font-size: 22.29px;
  font-weight: 400;
  text-align: center;
  color: #fef38b;
  margin-bottom: 0;
  text-decoration: none;

  :hover {
    color: #fef38b;
  }

  ${({ theme }) => theme.media.sm`
    font-size: 13px;
  `}
`

export const StyledActionButton = styled.button`
  display: block;
  width: 100%;
  max-width: 600px;
  height: 67.27px;
  margin: 0 auto;
  border-radius: 76.85px;
  background: #fef38b;
  border: none;
  cursor: pointer;

  font-size: 32px;
  font-weight: 700;
  line-height: 67.27px;
  text-align: center;
  color: #f65e0e;

  &:disabled {
    cursor: not-allowed;
  }

  ${({ theme }) => theme.media.sm`
    max-width: 340px;
    height: 46px;
    border-radius: 34.82px;
    font-size: 21px;
    line-height: 46px;
  `}
`
